import { put, takeLatest, all } from 'redux-saga/effects';
import { API_URL } from 'containers/App/constants';
import { GET_FILTERS } from './constants';
import { filtersLoaded } from './actions';
import { sortsLoaded } from '../HorizontalCatalogFilter/actions';
import { getRequestHeadersAsLogged, responseHandler } from '../../utils/auth';

function* fetchFilters() {
  const requestURL = `${API_URL}search/catalog/filters`;

  try {
    const parameters = {
      method: 'GET',
      headers: getRequestHeadersAsLogged(),
    };
    const request = yield fetch(requestURL, parameters).then(response =>
      responseHandler(response)
    );
    yield all([
      put(filtersLoaded(request.filters)),
      put(sortsLoaded(request.orders)),
    ]);
  } catch (error) {
    console.log('request error', error);
  }
}

function* actionWatcher() {
  yield takeLatest(GET_FILTERS, fetchFilters);
}

export default function* optionData() {
  yield all([actionWatcher()]);
}
